export interface IFollowUpLabOptionsData {
    id: number,
    centerId: number,
    isFollowUpNeeded: boolean,
    isLabOrdersOrPrintableLetters: boolean,
    isDeleted: boolean,
    optionText: string,
    filePath: string
}

export interface IFollowUpLabOptionsValidation {
    isFollowUpNeeded: boolean,
    isLabOrdersOrPrintableLetters: boolean,
    isOptionText: boolean
}